import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getBoardMemberPositions: {
        method: 'GET',
        url: `${BASE_PATH_API}/boardPositions`,
        isArray: true
    },
    updateBoardMemberTerm: {
        method: 'PUT',
        url: `${BASE_PATH_API}/boardMemberTerms/:boardMemberTermId`
    },
    createBoardMemberTerm: {
        method: 'POST',
        url: `${BASE_PATH_API}/boardMemberTerms`
    },
    deleteBoardMemberTerm: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/boardMemberTerms/:boardMemberTermId`
    },
    getBoardMembersByPropertyId: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:propertyId/boardMembers`,
        isArray: true
    },
    getBoardMemberTermSummaries: {
        method: 'GET',
        url: `${BASE_PATH_API}/boardMemberTerms`,
        params: {
            '$count': true
        }
    },
    getBoardMemberTermsByAssociationOwnerId: {
        method: 'GET',
        url: `${BASE_PATH_API}/boardMemberTerms/associationOwners/:userId`,
        params: {
            '$count': true
        }
    }
};

export function BoardMembersApi() {
    return createActions(actions);
}
